import type { RichTextEditorVariable } from '@enamelai/design-system'
import {
  AiVoiceTone,
  DEFAULT_AI_CHANNELS,
  DEFAULT_SMS_BOOKING_CONFIRMED,
  DEFAULT_SMS_BOOKING_UNCONFIRMED,
  DEFAULT_SMS_CANCEL,
  DEFAULT_SMS_RESCHEDULE,
  IAiReceptionistSettings,
} from '@dataTypes/index'

export const VOICES = [
  'Alloy',
  'Ash',
  'Ballad',
  'Cedar',
  'Coral',
  'Echo',
  'Marin',
  'Sage',
  'Shimmer',
  'Verse',
]

export const TONES = [
  { value: 'professional', label: 'Professional' },
  { value: 'casual', label: 'Casual' },
  { value: 'concise', label: 'Concise' },
] as const

export const LANGUAGES = [
  'English',
  'Spanish',
  'Chinese',
  'Tagalog',
  'Vietnamese',
  'Korean',
  'French',
  'Arabic',
]

export const emptyAiReceptionistSettings = (): IAiReceptionistSettings => ({
  clinic_id: '',
  enabled: false,
  name: '',
  voice_style: 'Marin',
  voice_tone: AiVoiceTone.Professional,
  controls: [],
  languages: ['English'],
  verification_enabled: true,
  verification_required_for: ['new_booking', 'reschedule', 'cancel'],
  verification_fields: ['name', 'date_of_birth'],
  queue_after: 3,
  answer_faqs: true,
  schedule_approved_types: true,
  reschedule_cancel: false,
  detect_urgent: true,
  create_callback_tasks: false,
  clinical_guidance: false,
  default_callback: '',
  emergency_callback: '',
  insurance_callback: '',
  default_response: 'Next business day',
  emergency_response: '20 minutes',
  insurance_response: '30 minutes',
  escalation_scenarios: [],
  prompt: '',
  services: [],
  information_database: '',
  knowledge_approved_services: '',
  knowledge_insurance_membership: '',
  knowledge_location_access: '',
  knowledge_restricted_actions: '',
  knowledge_restricted_enabled: false,
  knowledge_base_enabled: true,
  confirmation_template_id: '',
  reschedule_template_id: '',
  channels: [...DEFAULT_AI_CHANNELS],
  sms_booking_unconfirmed: DEFAULT_SMS_BOOKING_UNCONFIRMED,
  sms_booking_confirmed: DEFAULT_SMS_BOOKING_CONFIRMED,
  sms_reschedule: DEFAULT_SMS_RESCHEDULE,
  sms_cancel: DEFAULT_SMS_CANCEL,
  sms_default_response_value: 15,
  sms_default_response_unit: 'minutes',
  sms_answer_during_lunch: true,
  sms_answer_when_closed: true,
  created_by: '',
  updated_by: '',
})

export const AI_RECEPTIONIST_SMS_VARIABLES: RichTextEditorVariable[] = [
  { id: 'patient_name', label: 'Patient name', value: '{{patient_name}}' },
  { id: 'clinic_name', label: 'Clinic name', value: '{{clinic_name}}' },
  { id: 'date', label: 'Appointment date', value: '{{date}}' },
  { id: 'time', label: 'Appointment time', value: '{{time}}' },
  { id: 'provider_name', label: 'Provider name', value: '{{provider_name}}' },
  { id: 'service', label: 'Service', value: '{{service}}' },
]
